//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blok: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$mq === "sm";
    },
    backgroundColor() {
      return this.blok.background_color || "beige";
    },
    twoColorBackgrounds() {
      if (this.blok.background_type !== "two-color") {
        return null;
      }

      return [`top-${this.blok.top_color}`, `bottom-${this.blok.bottom_color}`];
    },
    imageFrameColor() {
      if (!this.blok.framed_images) {
        return null;
      }

      return this.blok.frame_color;
    },
    isCarousel() {
      return this.blok.is_carousel;
    },
    isReverse() {
      return this.blok.reverse_content;
    },
    isReverseMobile() {
      return this.blok.reverse_content_mobile;
    },
    backgroundImage() {
      if (this.blok.background_type !== "background-image") {
        return null;
      }

      return {
        "--background-image": `url(${this.blok.background_image.filename})`,
        "--background-image-mobile": `url(${
          this.blok.background_image_mobile.filename
        })`
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resizeBackgroundColor();

      setTimeout(() => {
        this.resizeBackgroundColor();
      }, 300);
    });

    window.addEventListener("resize", this.resizeBackgroundColor);
  },
  methods: {
    resizeBackgroundColor() {
      if (this.blok.background_type === "two-color") {
        const headerSection = this.$el.querySelector(
          ".two-column-section-content-text > .two-column-section-content-text-headings"
        );

        if (headerSection) {
          const height = headerSection.offsetHeight;
          const offset = this.isMobile ? 120 : 80;
          this.$el.style.setProperty("--header-height", `${height + offset}px`);
        }
      }
    },
    removeEventListener() {
      window.removeEventListener("resize", this.resizeBackgroundColor);
    }
  },
  beforeDestroy() {
    this.removeEventListener();
  }
};
